import ClientResetPass from "components/auth/clientLogin/ClientResetPass";

const ClientResetPasswordPage = () => {
  return <ClientResetPass />;
};

export default ClientResetPasswordPage;
